{
	"hoursShort": "{count} h",
	"templates": {
		"subsystems": {
			"ru:school": "RU School",
			"ru:university": "RU University",
			"ru:ege": "EGE",
			"ru:oge": "OGE",
			"ru:vpr": "VPR",
			"us:high-school": "US High School",
			"us:ap": "AP",
			"us:sat": "SAT",
			"us:mcat": "MCAT",
			"us:usmle": "USMLE",
			"uk:gcse": "GCSE",
			"uk:a-levels": "A-Levels",
			"kz:school": "KZ School",
			"kz:ent": "ENT",
			"de:abitur": "Abitur",
			"fr:bac": "Baccalauréat",
			"cn:gaokao": "Gaokao",
			"in:cbse": "CBSE",
			"in:icse": "ICSE",
			"other": "Other"
		}
	},
	"detail": {
		"back": "Back to plans"
	},
	"subsection": {
		"minutes": "{count} min",
		"doneShort": "done"
	},
	"generate": {
		"title": "Create study plan",
		"subtitle": "AI will build a plan for your goal and weekly hours",
		"bindings": {
			"title": "Attach materials and folders",
			"hint": "Optional. AI will build the plan from the content of selected materials and folders.",
			"materials": "Materials",
			"collections": "Folders"
		},
		"fields": {
			"completionDate": "Completion date",
			"examDateOptional": "(optional)",
			"weeklyHours": "Hours per week",
			"goal": "Goal / description",
			"goalPlaceholder": "e.g. prepare for EGE Biology in 4 months",
			"title": "Plan title",
			"titlePlaceholder": "e.g. Exam preparation"
		},
		"submit": "Create plan",
		"cancel": "Cancel",
		"generating": "Creating your plan...",
		"stepAnalyze": "Analyzing materials",
		"stepStructure": "Building sections",
		"stepActivities": "Mapping activities",
		"stepReady": "Ready",
		"quotaExceeded": "Study plan limit reached",
		"quotaUpgradeCTA": "Upgrade to Plus",
		"errorToast": "Failed to create plan",
		"failedTitle": "Could not generate plan",
		"failedHint": "Try again or change parameters. No quota was used.",
		"retry": "Retry"
	},
	"sourceStale": {
		"badge": "Source changed",
		"hint": "The source materials changed after generation. Regenerate to include the updates.",
		"regenerate": "Update"
	},
	"loadSettings": {
		"title": "Workload settings",
		"subtitle": "These settings apply to all plans.",
		"minutesLabel": "Minutes per day",
		"daysLabel": "Study days",
		"minDayHint": "Select at least one day",
		"saved": "Settings saved, the schedule is being recalculated",
		"error": "Failed to save settings"
	},
	"calendar": {
		"title": "Study calendar",
		"subtitle": "Lessons, exams and reviews across all plans for the month",
		"buttonLabel": "Calendar",
		"overrunWarning": "The material won't fit before the exam",
		"minutesTotal": "{count, plural, one {# minute} other {# minutes}}",
		"daysToExam": "{count, plural, =0 {Exam today} one {# day to exam} other {# days to exam}}",
		"moreLessons": "{count} more",
		"filterPlans": "Plans",
		"moved": "Lesson moved to {date}",
		"rescheduled": "Schedule updated",
		"todayButton": "Today",
		"prevMonth": "Previous month",
		"nextMonth": "Next month",
		"prevWeek": "Previous week",
		"nextWeek": "Next week",
		"filterPlansCount": "Plans ({count})",
		"filterReset": "Reset",
		"filterSearchPlaceholder": "Search a plan",
		"filterNoMatch": "No plans found",
		"filterSelectAll": "Select all",
		"moveTo": "Move to…",
		"moveError": "Couldn't move the lesson",
		"dayEmpty": "Nothing planned for this day",
		"dayNoLessons": "No lessons for this day",
		"minutesValue": "{count, plural, one {# minute} other {# minutes}}",
		"viewMonth": "Month",
		"viewAgenda": "List",
		"examDayDropHint": "Exam day — reserved for review",
		"overrunCta": {
			"cap": "More time per day",
			"date": "Shift the date",
			"scope": "Trim the plan"
		},
		"examCardTitle": "Exam: {planTitle}",
		"lessonLabel": "Lesson",
		"srsLabel": "Review",
		"examLabel": "Exam",
		"openLesson": "Open",
		"review": "Review",
		"overdueShort": "overdue",
		"srsEntryLine": "{count, plural, one {# to review} other {# to review}}",
		"examEntryLine": "Exam: {planTitle}",
		"noExamSoon": "No exams ahead",
		"selectDay": "Select day",
		"dayNamesShort": [
			"Mon",
			"Tue",
			"Wed",
			"Thu",
			"Fri",
			"Sat",
			"Sun"
		],
		"emptyPeriod": "No lessons in this period. The next one is on {date}.",
		"emptyPeriodJump": "Go there"
	},
	"intro": {
		"title": "The schedule is computed, not filled in",
		"body": "Lessons from every active course lay themselves out — within your daily budget of minutes and up to the exam date.",
		"bullets": [
			"One daily budget of minutes across all courses",
			"A lesson you moved by hand stays where you put it",
			"If the material will not fit before the exam, we say so"
		]
	}
}
